/**
 * apportion模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const apportion = {
  //分页
  page(params) {
    return $http.post(`${global.API_URL}/sme/apportion/page`,params);
  },
  //添加
  add(params) {
    return $http.post(`${global.API_URL}/sme/apportion/add`,params);
  },
  //编辑
  update(params) {
    return $http.post(`${global.API_URL}/sme/apportion/update`,params);
  },
  //检查当前成本分摊是否存在
  checkApportionIsExist(params) {
    return $http.post(`${global.API_URL}/sme/apportion/checkApportionIsExist`,params);
  },
  //查询
  select(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/apportion/select`,param);
  },
  //删除
  delete(id ,params) {
    let param = new URLSearchParams();
    param.append(id, params);
    return $http.post(`${global.API_URL}/sme/apportion/delete`,param);
  },
  //导出
  exportExcel(params) {
    return $http.post(`${global.API_URL}/sme/apportion/exportExcel`, params, {
      responseType: 'arraybuffer',
      timeout: 1000 * 60 * 5
    });
  }
}

export default apportion;



// WEBPACK FOOTER //
// ./src/api/apportion.js